import { useEffect, useState } from 'react';
import { IMediaItem, IListLibraryMediaResponse } from 'modules/media/interfaces/api';
import { BreadcrumbPath } from 'modules/media/services/hooks/useMediaExplorer';

type MutateFn = (path: string) => void;

export const useGetMedia = (
  data: IListLibraryMediaResponse | undefined,
  mutate: MutateFn
) => {
  const [pathStack, setPathStack] = useState<BreadcrumbPath[]>([]);
  const [currentPath, setCurrentPath] = useState<string>(' ');

  useEffect(() => {
    if (data?.path !== undefined) {
      setCurrentPath(data.path);
    }
  }, [data?.path]);

  const openFolder = (folder: IMediaItem) => {
    setPathStack(prev => [...prev, { label: folder.name, path: folder.path }]);
    mutate(folder.path);
  };

  const goRoot = () => {
    setPathStack([]);
    setCurrentPath(' ');
    mutate(' ');
  };

  const goToPathIndex = (index: number) => {
    const newStack = pathStack.slice(0, index + 1);
    setPathStack(newStack);

    const targetPath = newStack[index]?.path ?? ' ';
    setCurrentPath(targetPath);
    mutate(targetPath);
  };

  const onBack = () => {
    if (pathStack.length === 0) return;
    const newStack = pathStack.slice(0, -1);
    setPathStack(newStack);
    const targetPath = newStack.length > 0 ? newStack[newStack.length - 1].path : ' ';
    setCurrentPath(targetPath);
    mutate(targetPath);
  };

  return {
    items: data?.items ?? [],
    currentPath,
    pathStack,
    openFolder,
    goRoot,
    goToPathIndex,
    onBack,
  };
};
